import React from 'react';
import { Theme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const styles = {
    root: {
        backgroundImage: 'call',
        color: 'black',
    },
    gridItem: {
        padding: (theme: Theme) => theme.spacing(0.5)
    }
}

interface IMonitoringCallInfoBodyDetail {
    row: object;
}

export default function MonitoringCallInfoBodyDetail({ row }: IMonitoringCallInfoBodyDetail) {
    return (
        <Grid container alignItems="stretch" display="block" sx={styles.gridItem}>
            {Object.keys(row).map((key) =>
                <React.Fragment key={'key' + key.toString()}>
                    <Grid container spacing={1} sx={styles.gridItem}>
                        <Grid size={6}>
                            <Typography>{key}</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography>{(!row[key]) ? " " : row[key].toString()}</Typography>
                        </Grid>
                    </Grid>
                    <Divider />
                </React.Fragment>
            )}
        </Grid>
    );
}